export const ReportActionTypes = {
  SET_QUESTION_GRADE: "SET_QUESTION_GRADE",
};
